const DESKTOP_MEDIA = window.matchMedia("(min-width: 1000px)");
const STICKY_GALLERY_CLASS = "product--sticky-gallery";

function notifyStickyRecalculate() {
  document.dispatchEvent(
    new CustomEvent("height-observer:resize", {
      detail: { variable: "header" },
    }),
  );
}

function updateProductStickyColumn(product) {
  const gallery = product.querySelector(".product-gallery");
  const productInfo = product.querySelector(".product-info");

  if (!gallery || !productInfo || !DESKTOP_MEDIA.matches) {
    product.classList.remove(STICKY_GALLERY_CLASS);
    return;
  }

  const shouldStickGallery =
    gallery.getBoundingClientRect().height <=
    productInfo.getBoundingClientRect().height;

  product.classList.toggle(STICKY_GALLERY_CLASS, shouldStickGallery);
  notifyStickyRecalculate();
}

function initProductStickyColumns(product) {
  if (product.dataset.stickyColumnsInitialized === "true") {
    updateProductStickyColumn(product);
    return;
  }

  product.dataset.stickyColumnsInitialized = "true";

  const gallery = product.querySelector(".product-gallery");
  const productInfo = product.querySelector(".product-info");

  if (!gallery || !productInfo) {
    return;
  }

  const scheduleUpdate = () => {
    window.requestAnimationFrame(() => updateProductStickyColumn(product));
  };

  const resizeObserver = new ResizeObserver(scheduleUpdate);
  resizeObserver.observe(gallery);
  resizeObserver.observe(productInfo);

  DESKTOP_MEDIA.addEventListener("change", scheduleUpdate);
  window.addEventListener("load", scheduleUpdate, { once: true });

  const formId = product
    .closest("product-rerender")
    ?.getAttribute("observe-form");
  const form = formId ? document.forms[formId] : null;

  if (form && form.dataset.stickyColumnsListener !== "true") {
    form.dataset.stickyColumnsListener = "true";
    form.addEventListener("product:rerender", () => {
      window.requestAnimationFrame(initAllProductStickyColumns);
    });
  }

  gallery.addEventListener("carousel:settle", scheduleUpdate);

  scheduleUpdate();
}

function initAllProductStickyColumns() {
  document.querySelectorAll(".product").forEach((product) => {
    if (
      product.querySelector(".product-gallery") &&
      product.querySelector(".product-info")
    ) {
      initProductStickyColumns(product);
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAllProductStickyColumns);
} else {
  initAllProductStickyColumns();
}

document.addEventListener("shopify:section:load", initAllProductStickyColumns);
